var _defs, _rect, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "20d3c635cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 15 L 135.75 15 L 135.75 135.75 L 15 135.75 Z M 15 15 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    width: 180,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    width: 180,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    width: 180,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#20d3c635cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e8ea",
    d: "M 22.914062 14.714844 L 14.746094 22.894531 L 24.699219 32.847656 C 21.324219 34.863281 19.042969 38.511719 19.042969 42.730469 L 19.042969 112.0625 C 19.042969 118.445312 24.214844 123.617188 30.597656 123.617188 L 115.46875 123.617188 L 127.554688 135.703125 L 135.722656 127.53125 Z M 55.617188 31.175781 L 134.59375 110.15625 L 134.59375 42.730469 C 134.59375 36.347656 129.421875 31.175781 123.039062 31.175781 Z M 111.484375 54.285156 C 114.671875 54.285156 117.261719 56.875 117.261719 60.066406 C 117.261719 63.253906 114.671875 65.84375 111.484375 65.84375 C 108.296875 65.84375 105.707031 63.253906 105.707031 60.066406 C 105.707031 56.875 108.296875 54.285156 111.484375 54.285156 Z M 56.585938 80.296875 L 71.042969 97.675781 L 79.121094 87.269531 L 98.136719 106.285156 L 36.375 106.285156 Z M 56.585938 80.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.586cc514f649b63066e6cff9caaf1768.svg";
export { ForwardRef as ReactComponent };